'use client';
import clsx from 'clsx';

import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import { AlertOctagon } from '../icons/alertOctagon';

import { DownloadAudio } from './DownloadAudio';
import { Editor } from './Editor';
import { EditorHeader } from './EditorHeader';
import { PlayButton } from './Player';
import { ProsodyInput } from './ProsodyInput';
import { UpsellModal } from './UpsellModal';
import { VoiceList } from './VoiceList';

import styles from './styles.module.css';
import { useFeatureFlag } from '../../lib/useFeatureFlags';

export const VoiceDemo = () => {
  const { error, numGeneration } = useVoiceDemo();
  const { variant: audioGenerationLimit } = useFeatureFlag(
    'vo_demo_generationLimit',
    -1,
  );
  return (
    <div
      className="font-ABCDiatype text-glass-800 relative flex w-full max-w-[900px] flex-col gap-4 rounded-[32px] bg-white p-4 @sm:p-6"
      data-testid="voice-demo">
      <div className="flex flex-wrap items-center justify-between gap-4 @md:items-start">
        <div className="flex w-full justify-between gap-2 @sm:w-auto">
          <VoiceList />
          <ProsodyInput />
        </div>
        <div className="flex w-full gap-2 @sm:w-auto">
          <PlayButton />
          {(audioGenerationLimit === -1 ||
            audioGenerationLimit > numGeneration) && <DownloadAudio />}
        </div>
      </div>
      <div className="mx-[-16px] h-[1px] bg-[#F5F5FA] @sm:mx-[-24px]" />
      <div className="flex flex-col @lg:flex-row @lg:gap-4">
        <div className={clsx('flex-1 xl:w-11/12', styles.textAreaWrapper)}>
          <Editor />
        </div>
      </div>
      <EditorHeader />
      <UpsellModal />
      {error && (
        <p
          role="alert"
          className="absolute left-1/2 top-8 z-50 flex -translate-x-2/4 items-center gap-4 rounded-2xl bg-[#0000007f] p-4 text-white backdrop-blur-sm @lg:w-fit">
          <AlertOctagon className="text-xl text-[#FF4B40]" />
          {error.message}
        </p>
      )}
    </div>
  );
};
